import React from 'react'
import ReactMapboxGl from 'react-mapbox-gl'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import { ApiKeys, mapConfig } from '@lib/variables'
import * as S from './Mapbox.styled'

class MapBoxMap extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      Map: null,
    }
  }

  componentDidMount() {
    let that = this
    setTimeout(function () {
      if (!that.map) return
      const { map } = that.map.state
      map.addControl(
        new mapboxgl.FullscreenControl(),
        that.props.fullscreenButtonPosition
      )
      map.addControl(new mapboxgl.NavigationControl(), 'bottom-left')
      map.scrollZoom.disable()
      map.on('mousedown', function () {
        map.scrollZoom.enable()
      })

      const { visibleLayers } = that.props
      if (visibleLayers) {
        visibleLayers.length &&
          visibleLayers.map((layerName) => {
            map.setLayoutProperty(layerName, 'visibility', 'visible')
          })
      }

      document.addEventListener('fullscreenchange', function () {
        map.resize()
      })
    }, 1000)
  }

  render() {
    const {
      style,
      containerStyle,
      center,
      zoom,
      fitBounds,
      fitBoundsOptions,
      children,
      scrollZoom,
      onDragEnd,
      mapRef,
      scrollToContactForm,
    } = this.props
    const { Map } = this.state
    if (mapboxgl.supported() && !Map) {
      this.setState({
        Map: ReactMapboxGl({
          accessToken: ApiKeys.MAPBOX_KEY,
          scrollZoom: scrollZoom,
        }),
      })
    }
    if (Map) {
      return (
        <S.MapWrap>
          <Map
            {...this.props}
            style={style}
            containerStyle={containerStyle}
            center={center || mapConfig.defaultCenter}
            zoom={zoom}
            ref={(map) => {
              this.map = map
              mapRef && mapRef(map)
            }}
            fitBounds={fitBounds}
            fitBoundsOptions={fitBoundsOptions}
            onDragEnd={onDragEnd ? (e) => onDragEnd(e) : null}
            onRender={scrollToContactForm ? () => scrollToContactForm() : null}
          >
            {children}
          </Map>
        </S.MapWrap>
      )
    } else {
      return (
        <S.MapWrap>
          <h3>Please update your browser to view maps.</h3>
        </S.MapWrap>
      )
    }
  }
}

MapBoxMap.defaultProps = {
  style:
    process.env.NEXT_PUBLIC_MAPBOX_STYLE ||
    'mapbox://styles/barryplantgroup/cllert2xt00hg01q0bhlnbfnk',
  containerStyle: {
    height: '100%',
  },
  center: [144.96332, -37.814],
  zoom: [9],
  fullscreenButtonPosition: 'bottom-right',
}

// new style mapbox://styles/mapbox/streets-v12

export default MapBoxMap
